module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('button', {
    on: {
      "click": _vm.exportExcel
    }
  }, [_vm._t("default")], 2)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-47f99f0c!./~/vue-loader/lib/selector.js?type=template&index=0!./~/vue-excel-xlsx/VueExcelXlsx.vue
// module id = 988
// module chunks = 1